// Add your custom JS here!!!

// Change Read More to Listen Now on Podcast pages
jQuery(document).ready(function ($) {
  if ($("body").hasClass("post-type-archive-podcast")) {
    $(".understrap-read-more-link").text("Listen Now");
  }
});

// Change Read More... to Read More on archive pages
jQuery(document).ready(function ($) {
  if ($("body").hasClass("category")) {
    $(".understrap-read-more-link").text("Explore");
  }
});

// Change all form labels to h3
jQuery(document).ready(function ($) {
  $(".gform_wrapper form .gfield_label").each(function () {
    var content = $(this).text();
    $(this).replaceWith('<h3 class="gfield_label">' + content + "</h3>");
  });
}); 

// Set top level items to clickable
// Christian Living
jQuery(document).ready(function () {
  // Target the parent menu item by class name and add a click event
  jQuery(".lsm-menu-cl").on("click", function () {
    // Replace 'your-link-url' with the URL you want to navigate to
    window.location.href = "/christian-living/";
  });
});

// Good News
jQuery(document).ready(function () {
  // Target the parent menu item by class name and add a click event
  jQuery(".lsm-menu-gn").on("click", function () {
    // Replace 'your-link-url' with the URL you want to navigate to
    window.location.href = "/good-news/";
  });
});

// Bible Helps
jQuery(document).ready(function () {
  console.log("hello");
  // Target the parent menu item by class name and add a click event
  jQuery(".lsm-menu-bh").on("click", function () {
    // Replace 'your-link-url' with the URL you want to navigate to
    window.location.href = "/bible-helps/";
  });
});

// Uplook TV
jQuery(document).ready(function () {
  // Target the parent menu item by class name and add a click event
  jQuery(".lsm-menu-ut").on("click", function () {
    // Replace 'your-link-url' with the URL you want to navigate to
    window.location.href = "/uplook-tv/";
  });
});

//   TRIANLGELS !!!
document.addEventListener("DOMContentLoaded", function () {
  const canvas = document.getElementsByClassName("triangleCanvas");

  for (let i = 0; i < canvas.length; i++) {
    drawTriangles(canvas[i]);
  }
});

// on resize, redraw triangles
window.addEventListener("resize", function () {
  const canvas = document.getElementsByClassName("triangleCanvas");

  for (let i = 0; i < canvas.length; i++) {
    drawTriangles(canvas[i]);
  }
});

function drawTriangles(canvas) {
  var screenWidth = window.innerWidth;
  const ctx = canvas.getContext("2d");
  const triangleHeight = 85 * Math.sin(Math.PI / 3);
  const triangleWidth = 85;
  const spacing = 12; // Space between triangles

  //set canvas width based on screen size
  if (screenWidth > 992) {
    canvas.width = canvas.parentElement.offsetWidth / 5;
  }else if (screenWidth > 768) {
    canvas.width = canvas.parentElement.offsetWidth / 3;
  } else {
    canvas.width = canvas.parentElement.offsetWidth / 2.7;
  }

  var newHeight = canvas.parentElement.offsetHeight;

  canvas.height = canvas.parentElement.offsetHeight + 6;


  let emptyChance = 0.0; // Chance of a triangle being empty
  const rows = canvas.height / (triangleHeight + spacing / 2) + 1;
  const colsMax = canvas.width / (triangleWidth + spacing) - 1;
  let cols = colsMax;

  //change parent div height to match total rows and spaces
  //canvas.parentElement.style.height = triangleHeight * rows + spacing * rows + "px";

  //random number of columns with a max of mxCols

  //fill triangles yellow
  let colorOne = "#FFD31F";

  //no border
  ctx.strokeStyle = "transparent";

  // Function to convert hex to RGB
  function hexToRgb(hex) {
    let bigint = parseInt(hex.slice(1), 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;
    return { r, g, b };
  }

  // Function to convert RGB to hex
  function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  // Function to shade color
  function shadeColor(color, percent) {
    let { r, g, b } = hexToRgb(color);

    // Darken
    r = Math.floor((r * (100 + percent)) / 100);
    g = Math.floor((g * (100 + percent)) / 100);
    b = Math.floor((b * (100 + percent)) / 100);

    // Clamp to 255
    r = r < 255 ? r : 255;
    g = g < 255 ? g : 255;
    b = b < 255 ? b : 255;

    return rgbToHex(r, g, b);
  }

  function getRandomShade() {
    return Math.random() * 16 - 8; // generates a number betwee
  }

  function drawTriangle(x, y, upsideDown = false) {
    ctx.beginPath();
    let randomShade = getRandomShade();
    if (upsideDown) {
      ctx.moveTo(x, y);
      ctx.lineTo(x + triangleWidth / 2, y + triangleHeight);
      ctx.lineTo(x - triangleWidth / 2, y + triangleHeight);
      ctx.fillStyle = shadeColor(colorOne, randomShade);
      ctx.fill();
    } else {
      ctx.moveTo(x, y);
      ctx.lineTo(x + triangleWidth / 2, y - triangleHeight);
      ctx.lineTo(x - triangleWidth / 2, y - triangleHeight);
      ctx.fillStyle = shadeColor(colorOne, randomShade);
      ctx.fill();
    }
    ctx.closePath();
    ctx.stroke();
  }

  for (let i = 0; i < rows; i++) {
    //change cols at random by +3 or -3% without going over max
    cols += Math.floor(Math.random() * 3 - 1);
    if (cols > colsMax) {
      cols = colsMax;
    }
    for (let j = 0; j < cols; j++) {
      const x =
        j * (triangleWidth + spacing) +
        (i % 2) * (triangleWidth / 2 + spacing / 2);
      const y = i * (triangleHeight + spacing / 2);

        drawTriangle(x, y, false);
        var upsideDownY = y + spacing / 2;
        drawTriangle(x, upsideDownY, (upsideDownY = true));
      
    }
    colorOne = shadeColor(colorOne, -2.4);
  }
}
